export const passwordRequirements = [
  {
    title: 'Contains at least one digit (0-9)',
    regex: /(?=.*[0-9])/,
  },
  {
    title: 'Contains at least one special character from the set (![!@#$%^&*])',
    regex: /(?=.*[!@#$%^&*])/,
  },
  {
    title: 'Contains at least one lowercase letter (a-z)',
    regex: /(?=.*[a-z])/,
  },
  {
    title: 'Contains at least one uppercase letter (A-Z)',
    regex: /(?=.*[A-Z])/,
  },
  {
    title: 'Is at least 8 characters long',
    regex: /.{8,}/,
  },
];
